import { getLinkPathToGgrProject } from 'common/helpers/get-link-path-to-ggr-project.helper';
import { Price, Typography } from 'fronton-react';
import { TExtendedProject } from 'app-entities/projects/types/project.type';
import { GAPromoClick } from 'common/analytics/ga';
import { useAnalyticsView } from 'common/analytics/use-analytics-view';
import { useState, useRef } from 'react';
import { TSendCombinedVeiwEvent } from 'common/analytics/use-combine-promo-view';
import {
  card,
  card__caption,
  card__price,
  card__projectName,
  card__image,
  card__image_large,
  card__image__container
} from './styles';
import { ImageFallbackIcon } from './image-fallback-icon/image-fallback-icon';

export const ProjectCard = ({
  mainPictureLink,
  projectLibraryName,
  projectMinPrice,
  mainPictureLinkInWebPFormat,
  projectTransliteration,
  isLargeGallery,
  sendCombinedViewEvent,
  elementBlock,
  position,
}: Pick<
  TExtendedProject,
  | 'projectLibraryName'
  | 'mainPictureLink'
  | 'projectMinPrice'
  | 'mainPictureLinkInWebPFormat'
  | 'projectTransliteration'
> & {
  isLargeGallery: boolean;
  elementBlock: string;
  sendCombinedViewEvent: (data: TSendCombinedVeiwEvent) => void;
  position: number;
}) => {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);

  const classNamesForImage = `${card__image} ${isLargeGallery ? card__image_large : ''}`;

  const carfRef = useRef<HTMLAnchorElement>(null);
  useAnalyticsView({
    element: carfRef,
    sendEventCallback: () => {
      sendCombinedViewEvent({ position, creative: projectTransliteration });
    },
  });

  const onElementClick = () => {
    GAPromoClick({
      elementBlock: elementBlock,
      promotions: [{ name: elementBlock, creative: projectTransliteration, position }],
    });
  };

  return (
    <a
      ref={carfRef}
      data-testid="project-card"
      target="_blank"
      onClick={onElementClick}
      className={card}
      href={`${getLinkPathToGgrProject(projectTransliteration)}`}
      rel="noreferrer">
      {errorLoadingImage ? (
        <div
          data-testid={`inspiration-gallery-fallback-image-${projectTransliteration}`}
          className={classNamesForImage}>
          <ImageFallbackIcon />
        </div>
      ) : (
        <div className={card__image__container}>
          <picture>
            <source type="image/webp" srcSet={mainPictureLinkInWebPFormat} />
            <img
              className={classNamesForImage}
              src={mainPictureLink}
              alt={projectLibraryName ?? projectTransliteration}
              onError={() => setErrorLoadingImage(true)}
            />
          </picture>
        </div>
      )}

      <div className={card__caption}>
        {projectLibraryName && (
          <Typography
            color="text-primary"
            data-testid="inspiration-gallery-project-name"
            className={card__projectName}
            variant="s"
            size="body_long">
            {projectLibraryName}
          </Typography>
        )}

        {projectMinPrice && (
          <div className={card__price}>
            <Typography color="text-primary" variant="s" size="body_accent">
              от <Price inline variant="medium" size="l" units="₽" value={projectMinPrice} />
            </Typography>
          </div>
        )}
      </div>
    </a>
  );
};